import React, { useMemo, useState, useEffect, useRef } from "react";
import { Button, Form, Row, Col, Table } from "@themesberg/react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import {
  faArrowCircleDown,
  faArrowCircleUp,
  faRedoAlt,
} from "@fortawesome/free-solid-svg-icons";
import PaginationComponent from "../../../components/Pagination";
import useAllUserListing from "./useAllUserListing";
import Trigger from "../../../components/OverlayTrigger";
// import ClientFilter from '../../../components/ClientFilter'
// import PortalFilter from '../../../components/PortalFilter'
import { kycLabels, tableHeaders } from "./userConstant";
import DateRangePicker from "../../../components/DateRangePicker";
// import { formatDateYMD } from '../../../utils/dateFormatter'
import { format } from "date-fns";
import NotificationIcon from "../../../components/NotificationIcon";
import UsersFilter from "./components/UsersFilter";
import UsersTable from "./components/UsersTable";
import NotificationIconContainer from "../../../components/NotificationIcon/NotificationIconContainer";
import useTableCustom from "../../../components/CusotmFilter"
import TableErrorMessage from "../../../components/TableErrorMessage";
import ConfirmationModal from "../../../components/ConfirmationModal";

// import { DeleteConfirmationModal } from '../../../components/ConfirmationModal'






export default () => {
  const {
    limit,
    setLimit,
    page,
    setPage,
    search,
    setSearch,
    userData,
    totalPages,
    navigate,
    affiliateSearch,
    setAffiliateSearch,
    // selectedClient,
    // selectedPortal,
    // setSelectedPortal,
    // setSelectedClient,
    loading,
    kycOptions,
    setKycOptions,
    state,
    setState,
    promoCode,
    setPromoCode,
    activeUserId,
    phoneNumber,
    setPhoneNumber,
    setUserId,
    setSortBy,
    setOrderBy,
    over,
    setOver,
    selected,
    sortBy,
    setSelectedFilter,
    selectedFilter,
    onResetDateFiltered,
    restoreUser, setRestoreUser,
    onHandleRestoreduser,
    onhandleRestore,
    deletedFilter, setDeletdFilter,
    playerStatus, setPlayerStatus,
    totalCount
  } = useAllUserListing();



  const filterProps = useMemo(
    () => ({
      search,
      setSearch,
      phoneNumber,
      setPhoneNumber,
      kycOptions,
      setKycOptions,
      kycLabels,
      setAffiliateSearch,
      setUserId,
      setLimit,
      setPage,
      setOrderBy,
      setSortBy,
      setState,
      state,
      deletedFilter, setDeletdFilter,
      playerStatus, setPlayerStatus,
      promoCode,
      setPromoCode,

    }),
    [
      search,
      phoneNumber,
      kycOptions,
      state,
      deletedFilter,
      playerStatus,
       promoCode,
    ]
  );


  const headerRef = useRef(null);
  const filterRef = useRef(null);

  const [tableMaxHeight, setTableMaxHeight] = useState();



  const {
    visibleColumns,
    pageData,
    customColSetting,
    noDataFound,
    resetColumns
  } =
    useTableCustom(userData,
      tableHeaders,
      false,
      () => { },
      null,
      null,
      false,
      "",
      true,
      "Players_listing");

  useEffect(() => {
    const updateMaxHeight = () => {

      const headerHeight = headerRef.current?.offsetHeight || 0;
      const filterHeight = filterRef.current?.offsetHeight || 0;
      const responsiveTable = document.querySelector('.table-responsive');
      const totalHeight = headerHeight + filterHeight; // Add any margin/padding if needed
      const availableHeight = window.innerHeight - totalHeight - 125;
      if (window.innerWidth < 1000) {
        // For smaller screens: reset to full height
        if (responsiveTable) {
          responsiveTable.style.maxHeight = '100%';
          responsiveTable.style.overflowY = 'unset';
        }
        setTableMaxHeight('100%');
        return;
      }
      else {
        if (responsiveTable) {
          responsiveTable.style.maxHeight = `${availableHeight}px`;
          responsiveTable.style.overflowY = 'auto'; // ensure scrolling
        }

      }

      setTableMaxHeight(`${availableHeight}px`);
    };

    updateMaxHeight(); // initial run
    window.addEventListener("resize", updateMaxHeight);
    return () => window.removeEventListener("resize", updateMaxHeight);
  }, []);
  // Memoize the table props
  const tableProps = useMemo(
    () => ({
      loading,
      userData,
      navigate,
      selected,
      sortBy,
      over,
      setOver,
      setSortBy,
      setOrderBy,
      tableHeaders: visibleColumns,
      tableMaxHeight,
      restoreUser, setRestoreUser,
      onHandleRestoreduser
    }),
    [
      loading,
      userData,
      sortBy,
      over,
      visibleColumns,
      tableMaxHeight
    ]
  );
  return (
    <>
      <div className="section-header-wrap mt-n3 mx-n3" ref={headerRef}>
        <Row className="align-items-center">
          <Col lg={6} xs={6}>
            <h2 className="title-text">Players</h2>
          </Col>

          <Col lg={6} xs={6} className="text-end">
            <NotificationIconContainer />
          </Col>
        </Row>
      </div>
      <UsersFilter {...filterProps} resetColumns={resetColumns} filterRef={filterRef} customColSetting={customColSetting} setSelectedFilter={setSelectedFilter}
        selectedFilter={selectedFilter}
        onResetDateFiltered={onResetDateFiltered} />

      {visibleColumns?.length > 0 ? <div className="TableBg mt-4 pt-1">
        <UsersTable {...tableProps} />
        {userData?.count !== 0 && !loading && (
          <PaginationComponent
            page={userData?.count < page ? setPage(1) : page}
            totalPages={totalPages}
            setPage={setPage}
            limit={limit}
            setLimit={setLimit}
            totalCount={totalCount}
            countText="Total Players : "
            showTotalCount={true}
          />
        )}
      </div> : <TableErrorMessage />}

      {
        restoreUser?.isOpen &&
        <ConfirmationModal

          setShow={setRestoreUser}
          show={restoreUser.isOpen}
          handleYes={onHandleRestoreduser}
          title={"Restore Player"}

          subTitle={`Are you sure want to Restore the deleted ${restoreUser?.data?.username} ?`}

        />
      }


    </>
  );
};
